import { useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import { getSubLessonOrder, post_SubLessonOrder, post_SubLessonVideo } from "../services/SubLesson";
import { PleasewaitPopup } from "./PleasewaitPopup";


type AddSubLessonVideoProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshVideoList: (value: boolean) => void;
    subLessonId: number;
    lastVideoOrder: number
}

export const AddSubLessonVideo = ({ showPopup, setShowPopup, setRefreshVideoList, subLessonId, lastVideoOrder }: AddSubLessonVideoProps) => {
    const { auth }: any = useAuth();
    const [videoTitle, setVideoTitle] = useState<string>("");
    const [videoThumbnail, setVideoThumbnail] = useState<string>("");
    const [videoUrl, setVideoUrl] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    const handleOnSave = () => {
        if (subLessonId) {
            setShowPleasewait(true);
            post_SubLessonVideo({
                subLessonId: subLessonId,
                title: videoTitle,
                videoUrl: videoUrl,
                thumbnail: videoThumbnail,
                orderNumber: lastVideoOrder + 1,
                durationSeconds: 0,
                createdAt: new Date().toLocaleString(),
                createdBy: auth?.givenname,
            }, auth?.id)
                .then((res) => {
                    updateSubLessonOrder(res);
                    setShowPleasewait(false);
                    setShowPopup(false);
                    setRefreshVideoList(true);
                })
                .catch((error) => {
                    console.error(error)
                })


        }
    }


    const updateSubLessonOrder = (videoId: number) => {
        getSubLessonOrder(subLessonId)
            .then((data) => {
                if (data.length > 0) {

                    post_SubLessonOrder({
                        subLessonId: subLessonId,
                        contentId: 0,
                        videoId: videoId,
                        orderNumber: data[data.length - 1]?.orderNumber + 1
                    }, auth?.id)
                        .then((res) => {
                            setShowPleasewait(false);
                            setShowPopup(false);
                            setRefreshVideoList(true);
                        })
                        .catch((error) => {
                            console.log(error)
                        })

                }
                else {
                    post_SubLessonOrder({
                        subLessonId: subLessonId,
                        contentId: 0,
                        videoId: videoId,
                        orderNumber: 1
                    }, auth?.id)
                        .then((res) => {
                            setShowPleasewait(false);
                            setShowPopup(false);
                            setRefreshVideoList(true);
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }
    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-4xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add video</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>


                    <div>
                        <div className="px-6 pt-6 space-y-4">

                            <label className="font-medium">Video Title</label>
                            <input
                                type="text"
                                placeholder="Title"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={videoTitle}
                                onChange={(e) => setVideoTitle(e.target.value)}
                            />

                        </div>

                        <div className="px-6 pt-6 space-y-4">

                            <label className="font-medium">Video Thumbnail</label>
                            <input
                                type="text"
                                placeholder="Thumbnail"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={videoThumbnail}
                                onChange={(e) => setVideoThumbnail(e.target.value)}
                            />

                        </div>

                        <div className="px-6 py-6 space-y-4">

                            <label className="font-medium">Video Url</label>
                            <input
                                type="text"
                                placeholder="Url"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={videoUrl}
                                onChange={(e) => setVideoUrl(e.target.value)}
                            />

                        </div>


                    </div>

                    <div className="px-6 py-4 border-t flex justify-end space-x-3">

                        <button
                            className={`px-6 py-2 ${!videoTitle || !videoUrl ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={!videoTitle || !videoUrl ? true : false}
                            onClick={handleOnSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}